<template>
  <div class="warehouse">
    <div class="selectWarehouse">
      <el-select v-model="acriveWarehouse"
                 filterable
                 placeholder="请选择"
                 @change="changedata">
        <el-option v-for="item in cklist"
                   :key="item.id"
                   :label="item.name"
                   :value="item.index">
        </el-option>
      </el-select>
    </div>
    <div class="map_view">
      <el-amap vid="amap"
               :plugin="plugin"
               class="amap-demo"
               :center="center"
               mapStyle='light'>

        <el-amap-marker v-for="(marker,index) in markers"
                        :key="'marker'+index"
                        :position="marker.position"
                        :icon="marker.icon||''"
                        :events="marker.events"></el-amap-marker>
        <el-amap-text v-for="(marker,index) in markers"
                      :key="'text'+index"
                      :position="marker.position"
                      :text='marker.content'
                      :events="marker.events"
                      :offset='[0,-50]'>
        </el-amap-text>

        <el-amap-info-window v-if="window"
                             :position="window.position"
                             :visible="window.visible"
                             :content="window.content"
                             :offset="window.offset"></el-amap-info-window>

      </el-amap>
    </div>
  </div>
</template>

<script>
import { apiUserWarehouse } from '@/request/api'
import VueAMap from 'vue-amap'
export default {
  data () {
    let self = this
    return {
      acriveWarehouse: '',
      window: '',
      windows: [],
      cklist: [],
      center: [116.369276, 39.957538],
      markers: [],
      plugin: [{
        pName: 'Geolocation',
        events: {
          init (o) {
            // o是高德地图定位插件实例
            o.getCurrentPosition((status, result) => {
              if (result && result.position) {
                // 设置经度
                self.lng = result.position.lng
                // 设置维度
                self.lat = result.position.lat
                // 设置坐标
                self.center = [self.lng, self.lat]
                self.markers.push({
                  position: [self.lng, self.lat],
                  content: '您在这里',
                })
                self.loaded = true
                // 页面渲染好后
                self.$nextTick()
              }
            })
          }
        },
      }]
    }
  },
  // ftp://tywl99_com@8.129.144.147/img/login_AD.56aa0e19.png
  methods: {
    point (e) {
      console.log(e);
      let markers = this.markers;
      let windows = []
      let that = this
      e.cklist.forEach((item, index) => {
        markers.push({
          position: [item.lng, item.lat],
          content: item.name,
          icon: 'https://www.tuanyun99.com/logo.png',
          events: {
            click () {
              that.windows.forEach(window => {
                window.visible = false; //关闭窗体
              });
              that.window = that.windows[index];
              that.$nextTick(() => {
                that.window.visible = true;//点击点坐标，出现信息窗体
              });
            }
          }
        })
        windows.push({
          position: [item.lng, item.lat],
          content: `
          <div class='win_info'> ${item.name} </div>
          <div class='win_text'>联系人：${item.username}</div>
          <div class='win_text'>联系电话：${item.mobile}</div>
          <div class='win_text'>邮政编码：${item.zipcode}</div>
          <div class='win_text'>详细地址：${item.address}</div>
          <div class='ck_info'>仓库信息：${item.info}</div>
          `,//内容
          offset: [0, -50],//窗体偏移
          visible: false//初始是否显示
        })
      })
      //  加点
      this.markers = markers;
      //加弹窗
      this.windows = windows
    },
    // 
    //   ---------修改数据---------
    changedata (e) {
      this.center = [this.cklist[e].lng, this.cklist[e].lat]
      this.markers[parseInt(e) + 1].events.click()
    },
    // --------获取所有仓库位置--------
    async getAllWarehouse () {
      let res = await apiUserWarehouse({
        lng: this.center[0],
        lat: this.center[1]
      })
      if (res.errno == 0) {
        for (const key in res.cklist) {
          res.cklist[key].index = key
          res.cklist[key].lng == '' ? 0 : res.cklist[key].lng
          res.cklist[key].lat == '' ? 0 : res.cklist[key].lat
        }
        this.cklist = res.cklist

        this.point(res)

      } else {
        this.$message.error(this.message)
      }
    }
  },
  created () {
    this.getAllWarehouse()
  }

}
</script>

<style lang='scss'>
.warehouse {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .selectWarehouse {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding: 30px;
    justify-content: flex-end;
  }
  .amap-icon {
    img {
      width: 30px;
      height: 30px;
    }
  }
  .selectWarehouse {
    flex: 1;
    max-height: 60px;
  }
  .map_view {
    width: 100%;
    flex: 1;
    border-top: 2px solid #333;
    .win_info {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }
    .win_text {
      font-size: 14px;
      margin: 3px 0;
      color: #999;
    }
    .ck_info {
      font-size: 14px;
    }
    .amap-info-content {
      border-radius: 10px;
    }
    .amap-overlay-text-container {
      //   width: 80px;
      //   top: 0;
      padding: 1px 5px;
      text-align: center;
      border-radius: 50px;
      color: #fff;
      background-color: #4085fd;
      border: 0;
    }
  }
}
</style>